import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import Layout from "../../Layout/Layout";
import StudentProgressCard from "./StudentProgressCard/StudentProgressCard";
import "./StudentProgress.scss";
import { useChartContext } from "../../../../context/ChartContext";

const StudentProgress = ({ t, user }) => {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 767);
  const [isTabletView, setIsTabletView] = useState(
    window.innerWidth > 767 && window.innerWidth <= 991
  );
  const [isTabletOrMobileView, setIsTabletOrMobileView] = useState(
    window.innerWidth <= 991
  );

  const { selectedStudent } = useChartContext();

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 767);
      setIsTabletView(window.innerWidth > 767 && window.innerWidth <= 991);
      setIsTabletOrMobileView(window.innerWidth <= 991);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="student-progress-page">
      <Layout isReportAvailable={true} isMobileView={isMobileView}>
        <StudentProgressCard
          user={user}
          isTabletOrMobileView={isTabletOrMobileView}
          isMobileView={isMobileView}
          isTabletView={isTabletView}
          selectedStudent={selectedStudent}
        />
      </Layout>
    </div>
  );
};

export default withTranslation()(StudentProgress);